import { createFileRoute, Outlet } from '@tanstack/react-router'
import { IdCard, Palette, UserCog, Barcode, BadgeDollarSign } from 'lucide-react'
import { Separator } from '@/components/ui/separator'
import { Header } from '@/components/layout/header'
import { Main } from '@/components/layout/main'
import { ThemeSwitch } from '@/components/theme-switch'
import { AuthButton } from '@/features/auth'
import { SidebarNav } from '@/features/settings'
import { TransactionsDialog } from '@/features/transactions'

export const Route = createFileRoute('/_authenticated/settings')({
  component: Settings,
})

const sidebarNavItems = [
  {
    title: '个人资料',
    href: '/settings',
    icon: <UserCog size={18} />,
  },
  {
    title: '外观',
    href: '/settings/appearance',
    icon: <Palette size={18} />,
  },
  {
    title: '自定主角',
    href: '/settings/user-card',
    icon: <IdCard size={18} />,
  },
  {
    title: '邀请',
    href: '/settings/invite',
    icon: <Barcode size={18} />,
  },
  {
    title: '我的收益',
    href: '/settings/earnings',
    icon: <BadgeDollarSign size={18} />,
  },
]

export function Settings() {
  return (
    <>
      {/* ===== Top Heading ===== */}
      <Header>
        <div className='ms-auto flex items-center space-x-4'>
          <ThemeSwitch />
          <TransactionsDialog />
          <AuthButton />
        </div>
      </Header>

      <Main fixed>
        <div className='space-y-0.5'>
          <h1 className='text-2xl font-bold tracking-tight md:text-3xl'>
            设置
          </h1>
          <p className='text-muted-foreground'>设置您的账户设置和外观偏好。</p>
        </div>
        <Separator className='my-4 lg:my-6' />
        <div className='flex flex-1 flex-col space-y-2 overflow-hidden md:space-y-2 lg:flex-row lg:space-y-0 lg:space-x-12'>
          <aside className='top-0 lg:sticky lg:w-1/5'>
            <SidebarNav items={sidebarNavItems} />
          </aside>
          <div className='flex w-full overflow-y-hidden p-1'>
            <Outlet />
          </div>
        </div>
      </Main>
    </>
  )
}
